// Per-customer brand logos (Atlas + field-schematic, Layer 2). Single source of
// truth so a logo is wired once. Add one line + drop the file in
// public/client-logos/ to give a customer their real logo; any client without an
// entry falls back to the initials monogram (so no missing-image 404s). Move to a
// clients.logo_url DB field when customers self-manage their own branding.
export const CLIENT_LOGOS: Record<number, string> = {
  51: "/client-logos/51.png", // Valeura Energy
  541: "/client-logos/541.png", // SAK CHAISIDHI CO.,LTD.
  // <client_id>: "/client-logos/<file>.png",
};
